export default __webpack_public_path__ + "static/media/main box1.e48f5706.png";